import { HsaFsaCheckLogo } from '@jouzen/ecom-components/icons/HsaFsaCheckLogo';
import { InfoModal } from '@jouzen/ecom-components/v3/InfoModal';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import RichText from '@/app/components/RichText';
import { useHsaFsa } from '@/app/hooks/useHsaFsa';

export interface HsaFsaEligibleProps {
  readonly isEligible: boolean;
}

const HsaFsaEligible = ({ isEligible }: HsaFsaEligibleProps) => {
  const hsaFsa = useHsaFsa();
  const t = useTranslations();

  if (isEligible && hsaFsa.isAvailable) {
    return (
      <div
        className="mb-3 flex h-10 w-full items-center rounded-xl bg-gray-300/35 pr-1.5 pl-4 text-sandstone-500"
        data-cy="build-hardware-order-hsa-fsa"
      >
        <div className="mr-auto flex items-center">
          <HsaFsaCheckLogo className="mr-2" height="14" width="13" />
          <Typography className="text-sm" color="dark" weight="bold">
            <RichText messageKey="ring_pdp_2025_hsa_fsa_eligible_label" />
          </Typography>
        </div>
        <InfoModal
          media={{
            image: (
              <Image
                className="size-full object-cover"
                localizedAlt="ring_pdp_2025_hsa_fsa_modal_img_alt"
                height="217"
                src="hardware-pdp/modal/hsa-fsa-eligible.jpg"
                width="386"
              />
            ),
          }}
          rightColumnContent={
            <div className="lg:pt-5">
              <Typography className="mb-3 text-base font-bold md:text-xl md:font-normal">
                <RichText messageKey="ring_pdp_2025_hsa_fsa_modal_heading" />
              </Typography>
              <ul className="list-outside list-disc space-y-0.5 pl-6 text-sm font-normal">
                <RichText messageKey="ring_pdp_2025_hsa_fsa_modal_list" />
              </ul>
            </div>
          }
          title={<RichText messageKey="ring_pdp_2025_hsa_fsa_modal_title" />}
          triggerButton={{
            label: t('ring_pdp_2025_hsa_fsa_eligible_info_label'),
          }}
        />
      </div>
    );
  } else {
    return null;
  }
};

export default HsaFsaEligible;
